import { computed, createApp, onMounted, onUnmounted, ref } from 'vue';
import { pinia } from '../../store/main.js'
import { useShopStore } from '../../store/shop.js'
import { debugLogger } from '../../helpers/debugLogger.js';
// Loop through each block to create multiple instance on the page.
// Added timeout to give menu cache a chance
setTimeout(() => {
  const carts = document.querySelectorAll('.wwf-cart-icon')

  carts.forEach(element => {
    // Create a vue instance.
    createApp({
      setup () {
        const shop = useShopStore()
        const itemCount = computed(() => {
          let sum = 0

          shop.orderItems.forEach((item) => {
            sum += Number(item.quantity)
          })

          return sum
        })

        const cartUrl = computed(() => {
          return Drupal.url('koszyk')
        })

        const isTabActive = ref(document.visibilityState === 'visible');

        const handleVisibilityChange = () => {
          if (document.visibilityState === 'visible') {
            isTabActive.value = true;
            debugLogger('Tab has become active');
            // refresh cart data
            if (!shop.loading) {
              shop.fetchCart();
            }
          } else {
            isTabActive.value = false;
          }
        }

        const goToCartClickHandler = (event) => {
          shop.updateCurrentStage('Cart')

          let parentElement = event.target.parentElement;

          if (parentElement.getAttribute('href') !== window.location.pathname) {
            let href = parentElement.getAttribute('href')

            if (href) {
              window.location.href = href
            } else {
              // Set a delay and retry once
              setTimeout(() => {
                href = parentElement.getAttribute('href');
                if (href) window.location.href = href;
              }, 100);
            }
          }
        }

        onMounted(() => {
          // Listen for visibility change events
          document.addEventListener('visibilitychange', handleVisibilityChange);
        });

        onUnmounted(() => {
          // Clean up the event listener when the component unmounts
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        });

        return { itemCount, cartUrl, goToCartClickHandler }
      }
    }).use(pinia).mount(element)
  })
}, 150)
